import React from 'react';
import { Minus, TrendingDown, TrendingUp } from 'lucide-react';
import { formatReportDelta, formatReportValue } from '../../utils/reportFormat';
import type { ReportValueFormat } from '../../types/monthlyClubReport';
interface DeltaLineProps {
  current: number;
  compared: number;
  /** "Aug" or "Sep 2025" */
  label: string;
  format: ReportValueFormat;
  /** When true, a decrease is good (e.g. cancellations) */
  inverse?: boolean;
  /** "delta" shows "+17 vs Aug (1,231)"; "change" shows "+17 vs Aug"; "value" shows "vs Aug 12.6%" */
  mode?: 'delta' | 'change' | 'value';
}

// Comparison line styled like TrendIndicator, but for absolute changes
export function DeltaLine({
  current,
  compared,
  label,
  format,
  inverse = false,
  mode = 'delta'
}: DeltaLineProps) {
  const delta = Math.round((current - compared) * 100) / 100;
  const isGood = inverse ? delta < 0 : delta > 0;
  const colorClass = delta === 0 ? 'text-[#64748B]' : isGood ? 'text-[#10B981]' : 'text-[#EF4444]';
  const Icon = delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
  return <div className={`flex items-center gap-1 text-xs ${colorClass}`} data-id="element-3575" data-mp="6bqsds1ahz0r">
      <Icon className="w-3 h-3 flex-shrink-0" aria-hidden="true" data-id="element-3576" data-mp="6az12teq6nga" />
      {mode !== 'value' ? <span data-id="element-3577" data-mp="3op84t04yqo1k">
          <span className="font-medium" data-id="element-3578" data-mp="3onnddjdy3l7x">{formatReportDelta(delta, format)}</span>
          <span className="text-[#64748B]" data-id="element-3579" data-mp="3tn9qlstrx1gq">
            {' '}
            vs {label}
            {mode === 'delta' && ` (${formatReportValue(compared, format)})`}
          </span>
        </span> : <span data-id="element-3580" data-mp="3jrg2dc6ozjj4">
          <span className="text-[#64748B]" data-id="element-3581" data-mp="3jry9j3uw7i5t">vs {label} </span>
          <span className="font-medium" data-id="element-3582" data-mp="35rnhhxhujxj2">
            {formatReportValue(compared, format)}
          </span>
        </span>}
    </div>;
}